function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Debounce } from '@/utils/validate';
import throttle from '@/utils/throttle';
import * as fudouActiveApi from '@/api/fudouActiveApi.js';
import * as logistics from '@/api/logistics';
import * as storeApi from '@/api/store';
import * as companyApi from '@/api/companyApi.js';
export default {
  components: {},
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {},
      supplierLists: [],
      addresData: [],
      initLoading: false
    };
  },
  mounted: function mounted() {
    this.getCityList();
  },
  methods: {
    throttle: throttle,
    openInit: function openInit(tagDetails, initSupplierId, initSupplierName) {
      var _this = this;
      this.pram = {};
      this.searchSupplier(initSupplierName || '');
      this.$set(this.pram, 'supplierId', initSupplierId || null);
      if (!(tagDetails !== null && tagDetails !== void 0 && tagDetails.id)) {
        this.visible = true;
        return;
      }
      ;
      this.initLoading = true;
      companyApi.detailHouse(tagDetails.id).then(function (res) {
        _this.initLoading = false;
        _this.pram = _objectSpread({}, res || {});
        _this.visible = true;
      });
    },
    handerSubmit: Debounce(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        var _ref = _this2.pram || {},
          id = _ref.id;
        companyApi[id ? 'updateHouse' : 'createHouse'](_this2.pram).then(function (data) {
          // companyApi[id ? 'updateHouse' : 'cardAddArticle'](this.pram).then((data) => {
          _this2.$message.success('操作成功');
          _this2.loading = false;
          _this2.visible = false;
          _this2.$emit('doRefresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    searchSupplier: function searchSupplier() {
      var _this3 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.supplierLists = [];
      storeApi.getSupplierApi({
        keyword: keyword
      }).then(function (res) {
        _this3.supplierLists = res || [];
      });
    },
    handleSupplierSearch: function handleSupplierSearch(data) {
      var _this4 = this;
      this.throttle(function () {
        _this4.searchSupplier(data);
      }, 300)();
    },
    getCityList: function getCityList() {
      var _this5 = this;
      this.addresData = [];
      logistics.treeLevel3().then(function (res) {
        _this5.addresData = res || [];
      });
    },
    //上传图片
    modalPicTap: function modalPicTap(tit, dataIndex) {
      var _this6 = this;
      this.$modalUpload(function (img) {
        _this6.$set(_this6.pram, dataIndex, img[0].sattDir);
      }, tit, 'system');
    },
    removeImg: function removeImg(dataIndex) {
      this.$set(this.pram, dataIndex, '');
    }
  }
};